<template><div><!--THIS FILE IS AUTOGENERATED, DONOT EDIT IT-->
<h2>Components</h2>
<hr>
<h3>Actionsheet_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/actionsheet/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/actionsheet">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/actionsheet" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Actionsheet.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Actionsheet } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if showing the component; use v-model for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-cancel</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if showing the cancel menu; invalid for android theme</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td>cancel(取消)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text of cancel menu</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">theme</span></td>
<td><span class="type type-string">String</span></td>
<td>ios</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>theme of menus, can be in [‘ios’, ‘android’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">menus</span></td>
<td><span class="type type-object">Object</span><br><span class="type type-array">Array</span></td>
<td>{}</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>menu items, for example: <code>{menu1: 'some text'}</code>, menu name with <code>.noop</code> will not trigger click events. <br><code>Menus</code> supports array since <code>v2.1.0</code>. Keys can be customized. More details below.</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-clicking-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.0.0</span></td>
<td>if closing actionsheet when clicking on mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-clicking-menu</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.8</span></td>
<td>if hide automatically when clicking on menus</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu</span></td>
<td>(menuKey, menuItem)</td>
<td>triggers when clicking on the menu</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu-{menuKey}</span></td>
<td>(menuKey)</td>
<td>shortcut event for easier listening, <code>menuKey</code> is related to <code>label</code>. For exapmple, you can listen on <code>on-click-menu-delete</code> if you have a menu named <code>delete</code></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu-cancel</span></td>
<td> </td>
<td>triggers when clicking on the cancel menu</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-mask</span></td>
<td> </td>
<td>triggers when clicking on mask</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.4</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/actionsheet">Demo page</a></p>
<p>From <code>v2.1.0</code>, <code>menus</code> supports type: Array.</p>
<p><code>label</code>: label name，you can use simple text or <code>html</code></p>
<p><code>value</code>: event name，if not specified, no <code>on-click-menu</code> will be emitted</p>
<p><code>type</code>:</p>
<ul>
<li><code>primary</code> primary color</li>
<li><code>warn</code> warn color</li>
<li><code>disabled</code> gray color, the menu cannot be clicked</li>
<li><code>info</code> the menu item shows as a tip, the same function as <code>key.noop</code> when setting menus by <code>Object</code>.</li>
</ul>
<pre class="hljs"><code>[{
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Are you sure?&lt;br/&gt;&lt;span style="color:#666;font-size:12px;"&gt;Once deleted, you will never find it.&lt;/span&gt;'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'info'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Primary'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'primary'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'primary'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Warn'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'warn'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Disabled'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'disabled'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Default'</span>
}]
</code></pre>
<hr>
<h3>Alert_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/alert/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/alert">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/alert" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Alert.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Alert } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>This component can be imported as plugin:</p>
<p class="warning">
When importing it as plugin, the usage is different from it in `template`. Please use  `little camel-case`  such as `buttonText` instead of `button-text`.
</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span>  { AlertPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(AlertPlugin)

<span class="hljs-comment">// or the way of umd</span>
<span class="hljs-comment">// import built js file</span>
Vue.use(vuxAlertPlugin)
</code></pre>
<pre class="hljs"><code><span class="hljs-comment">// show</span>
<span class="hljs-keyword">this</span>.$vux.alert.show({
  <span class="hljs-attr">title</span>: <span class="hljs-string">'Vux is Cool'</span>,
  <span class="hljs-attr">content</span>: <span class="hljs-string">'Do you agree?'</span>,
  onShow () {
    <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Plugin: I\'m showing'</span>)
  },
  onHide () {
    <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Plugin: I\'m hiding'</span>)
  }
})
<span class="hljs-comment">// hide</span>
<span class="hljs-keyword">this</span>.$vux.alert.hide()
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of the component, use v-model for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.0</span></td>
<td>alert content, and will be replaced if using slot:default</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">button-text</span></td>
<td><span class="type type-string">String</span></td>
<td>ok(确定)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if closing dialog when clicking on mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-fade</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>mask transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>zIndex of mask</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>dialog content</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when dialog shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when dialog is closed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/alert">Demo page</a></p>
<hr>
<h3>Badge_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/badge/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/badge">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/badge" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Badge.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Badge } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text of the Badge</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/badge">Demo page</a></p>
<hr>
<h3>Blur_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/blur/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/blur">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/blur" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Blur.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Blur } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">blur-amount</span></td>
<td><span class="type type-number">Number</span></td>
<td>10</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>blur amount of the effect</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">url</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>url of the image</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">height</span></td>
<td><span class="type type-number">Number</span></td>
<td>200</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>height of the container</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content of the container, above the blur image</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/blur">Demo page</a></p>
<hr>
<h3>ButtonTab_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/button-tab/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/button-tab">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/button-tab" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/ButtonTab.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { ButtonTab, ButtonTabItem } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

</code></pre>
<p><span class="vux-component-name">ButtonTab</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>current index, start from 0, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">height</span></td>
<td><span class="type type-number">Number</span></td>
<td>30</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>height in px</td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">ButtonTabItem</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">selected</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if selected</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-item-click</span></td>
<td>(index)</td>
<td>emits when item is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/button-tab">Demo page</a></p>
<hr>
<h3>Calendar_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/calendar/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/calendar">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/calendar" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Calendar.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Calendar } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<pre class="hljs"><code>  <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">calendar</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"title"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">calendar</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
</code></pre>
<p class="tip">`calendar` can be only used in `Group`
<br>
Except `title` and `value`, other `props` are the same as those of `inline-calendar`.
</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form value, binding by v-model. Empty means single seleciton; [] means multiple selection. When the value is “TODAY”, can quick pick current date. <code>placeholder</code> is valid only when the value is empty or [].</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text of label</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-popup-header</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.0</span></td>
<td>whether show popup header. Show under multiple selection mode; hide under single selection mode.</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">popup-header-title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.0</span></td>
<td>popup header title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">display-format</span></td>
<td><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>format value before displaying in cell</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">readonly</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.2</span></td>
<td>whether disable selecting</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td>(value)</td>
<td>emits when value changes</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when popup shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when popup hides</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/calendar">Demo page</a></p>
<hr>
<h3>Card_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/card/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/card">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/card" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Card.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Card } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">header.title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>title of header, not show without specify content</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">footer.title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>title of footer, not show without specify content</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">footer.link</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>link in the bottom, normal url or a v-link argument</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">header</span></td>
<td>header</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td>content, the main body part</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">footer</span></td>
<td>footer</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-footer</span></td>
<td> </td>
<td>emits when clicking the footer</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-header</span></td>
<td> </td>
<td>emits when clicking the header</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/card">Demo page</a></p>
<hr>
<h3>CellBox_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/cell-box/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/cell-box">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/cell-box" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/CellBox.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { CellBox } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-link</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if this is a link; if true, there will be an arrow on the right</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">link</span></td>
<td><span class="type type-string">String</span><br><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>redirect link. Can be http(s) protocol; can also be vue-router format</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">border-intent</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.1</span></td>
<td>if set border intent on the left side</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">align-items</span></td>
<td><span class="type type-string">String</span></td>
<td>center</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.5</span></td>
<td>flexbox align-items setting</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content body</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/cell-box">Demo page</a></p>
<hr>
<h3>CellFormPreview_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/cell-form-preview/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/cell-form-preview">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/cell-form-preview" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/CellFormPreview.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { CellFormPreview } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">list</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.0</span></td>
<td>label and value list</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">border-intent</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.1</span></td>
<td>if set border intent on the left side</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/cell-form-preview">Demo page</a></p>
<hr>
<h3>Cell_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/cell/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/cell">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/cell" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Cell.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Cell } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label text on the left</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>right text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">inline-desc</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the text below title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">link</span></td>
<td><span class="type type-string">String</span><br><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>redirect link. Can be http(s) protocol; can also be vue-router format</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-link</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if this is a link; if true, there will be an arrow on the right</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">primary</span></td>
<td><span class="type type-string">String</span></td>
<td>title</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>main content area, can be in [‘title’, ‘content’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-loading</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.0</span></td>
<td>if show loading icon, good for asynchronous loading</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value-align</span></td>
<td><span class="type type-string">String</span></td>
<td>left</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.0</span></td>
<td>value’s text-align，one of left, right. prop:primary will be set to content if value-align value is right</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">border-intent</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.1</span></td>
<td>if set border intent on the left side</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">arrow-direction</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.1</span></td>
<td>arrow direction, one of up, down</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.2</span></td>
<td>set disabled style for label and arrow (if is-link is true)</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">align-items</span></td>
<td><span class="type type-string">String</span></td>
<td>center</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>align-items value</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>right area, you can use default slot instead of prop:value so you can use complicated layout</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td>[deprecated] the same as default slot</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">icon</span></td>
<td>icon area before title</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">after-title</span></td>
<td>after title</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">child</span></td>
<td>the child element of the cell, you can add an element with absolute position</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">inline-desc</span></td>
<td>inline-desc slot, the same function as prop:inline-desc but can use html</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td>title slot</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.3</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/cell">Demo page</a></p>
<hr>
<h3>CheckIcon_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/check-icon/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/check-icon">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/check-icon" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/CheckIcon.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { CheckIcon } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.8</span></td>
<td>if selected, use :value.sync for two-way data binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>unknown</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>style of check icon, can be [‘plain’]</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/check-icon">Demo page</a></p>
<hr>
<h3>Checker_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/checker/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/checker">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/checker" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Checker.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Checker } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><code>Checker</code> is a more flexible component than <code>Radio</code> and <code>Checklist</code>.</p>
<p><span class="vux-component-name">Checker</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default-item-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>default checker-item classname</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">selected-item-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>selected check-item classname</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled-item-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>disabled check-item classname</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>radio</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>checker type, should be raido or checkbox</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span><br><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>selected value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>max selected number when type = checkbox</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">radio-required</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.3</span></td>
<td>whether value is required in radio mode. if true, current selected item will always be selected even after clicking</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>emits when value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">CheckerItem</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>value of current checker-item</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if current item is disabled</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-item-click</span></td>
<td><code>(itemValue, itemDisabled)</code></td>
<td>emits when current checker-item is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/checker">Demo page</a></p>
<hr>
<h3>Checklist_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/checklist/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/checklist">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/checklist" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Checklist.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Checklist } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">required</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if required</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">options</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>options list</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>max selected number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>min selected number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">random-order</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if place options in a random order</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">check-disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.1</span></td>
<td>if disabled item when selectedItems.length === total.length, by using this prop:max no longer works</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label-position</span></td>
<td><span class="type type-string">String</span></td>
<td>right</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.4</span></td>
<td>label position, can be set to left or right</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.8</span></td>
<td>if disable user from selecting</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td>(value, label)</td>
<td>emits when value changes, param:label is supported after v2.5.7</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">getFullValue</span></td>
<td> </td>
<td>get current value with label</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/checklist">Demo page</a></p>
<hr>
<h3>Clocker_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/clocker/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/clocker">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/clocker" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Clocker.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Clocker } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">time</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the end time</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">format</span></td>
<td><span class="type type-string">String</span></td>
<td>%D 天 %H 小时 %M 分 %S 秒</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the result format</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>if specified, will be the format for the result</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-tick</span></td>
<td> </td>
<td>triggers on time ticking</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-finish</span></td>
<td> </td>
<td>triggers on time end</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/clocker">Demo page</a></p>
<hr>
<h3>ColorPicker_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/color-picker/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/color-picker">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/color-picker" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/ColorPicker.vue" target="_blank">Demo source</a></span></p>
<p class="warning">This Component is Deprecated. use cell and slot instead</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { ColorPicker } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">colors</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>color list</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">size</span></td>
<td><span class="type type-string">String</span></td>
<td>large</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button size, enum: large, middle, small</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/color-picker">Demo page</a></p>
<hr>
<h3>Confirm_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/confirm/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/confirm">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/confirm" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Confirm.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Confirm } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of the component</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-input</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>whether show input or not. If true, slot will not work</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>placeholder of prompt, valid when show-input is true</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">theme</span></td>
<td><span class="type type-string">String</span></td>
<td>ios</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog’s style, can be ios or android</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if closing dialog when clicking on mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog content, can use html. Invalid when using slot</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">confirm-text</span></td>
<td><span class="type type-string">String</span></td>
<td>确认(confirm)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text of confirm button</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td>取消(cancel)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text of cancel button</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-fade</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>mask’s transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>dialog’s transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-confirm</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>whether close automatically when confirm button is clicked</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">input-attrs</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.7</span></td>
<td>input attributes</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>zIndex of mask</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>body content of the dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-cancel</span></td>
<td> </td>
<td>triggers when the cancel button is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-confirm</span></td>
<td>(value)</td>
<td>triggers when the confirm button is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>triggers when the dialog shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>triggers when the dialog hides</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">v2.6.4</span></td>
<td> </td>
<td>[feature] support prop:mask-z-index</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">setInputValue</span></td>
<td>(value)</td>
<td>set input value when show-input is true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.5</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/confirm">Demo page</a></p>
<hr>
<h3>Countdown_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/countdown/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/countdown">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/countdown" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Countdown.vue" target="_blank">Demo source</a></span></p>
<p class="warning">This Component is Deprecated. </p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Countdown } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-number">number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>total sections</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">start</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if start counting down</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/countdown">Demo page</a></p>
<hr>
<h3>Countup_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/countup/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/countup">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/countup" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Countup.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Countup } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">start-val</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>min number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">end-val</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>max number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">decimals</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>decimal length</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">duration</span></td>
<td><span class="type type-number">Number</span></td>
<td>2</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>duration value (second)</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">options</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>options for <code>countup.js</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">start</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if start counting automatically</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">tag</span></td>
<td><span class="type type-string">String</span></td>
<td>span</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.5</span></td>
<td>render tag</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/countup">Demo page</a></p>
<hr>
<h3>DatetimeRange_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/datetime-range/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/datetime-range">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/datetime-range" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/DatetimeRange.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { DatetimeRange } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form’s value, use <code>v-model</code> for binding. For example, [‘2017-01-15’, ‘03’, ‘05’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">inline-desc</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>description of the cell</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder, works when <code>value</code> is empty</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">start-date</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>start date (YYYY-MM-DD)</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">end-date</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>end date (YYYY-MM-DD)</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">format</span></td>
<td><span class="type type-string">String</span></td>
<td>YYYY-MM-DD</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>display format for date column</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>$emits when value changes, <code>(newVal)</code></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/datetime-range">Demo page</a></p>
<hr>
<h3>DatetimeView_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/datetime-view/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/datetime-view">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/datetime-view" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/DatetimeView.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { DatetimeView } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form’s value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">format</span></td>
<td><span class="type type-string">String</span></td>
<td>YYYY-MM-DD</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>display format for date column</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">render</span></td>
<td> </td>
<td>re-render component</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/datetime-view">Demo page</a></p>
<hr>
<h3>Datetime_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/datetime/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/datetime">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/datetime" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Datetime.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Datetime } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">format</span></td>
<td><span class="type type-string">String</span></td>
<td>YYYY-MM-DD</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>date format. Special characters are not supported, for example, YYYY-MM-DD HH:mm:ss</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>cell title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form’s value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">inline-desc</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>description of the cell</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder, works when value is empty</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min-year</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>min-year of the form</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max-year</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>max-year of the form</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min-hour</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>min hour</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max-hour</span></td>
<td><span class="type type-number">Number</span></td>
<td>23</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>max hour</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">confirm-text</span></td>
<td><span class="type type-string">String</span></td>
<td>ok(确认)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>confirm button’s text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td>cancel(取消)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>cancel button’s text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">clear-text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>custom button’s text which shows in the middle of the header</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">year-row</span></td>
<td><span class="type type-string">String</span></td>
<td>{value}</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>render template for the year column</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">month-row</span></td>
<td><span class="type type-string">String</span></td>
<td>{value}</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>render template for the month column</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">day-row</span></td>
<td><span class="type type-string">String</span></td>
<td>{value}</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>render template for the day column</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hour-row</span></td>
<td><span class="type type-string">String</span></td>
<td>{value}</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>render template for the hour column</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">minute-row</span></td>
<td><span class="type type-string">String</span></td>
<td>{value}</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>render template for the minute column</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">start-date</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>start date, must be YYYY-MM-DD. Please use <code>min-hour</code> and <code>max-hour</code> to limit the range of hours</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">end-date</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>end date, must be YYYY-MM-DD. Please use <code>min-hour</code> and <code>max-hour</code> to limit the range of hours</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">required</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if required</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">display-format</span></td>
<td><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.11</span></td>
<td>used to format display value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">readonly</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.6</span></td>
<td>readonly mode, show like a cell</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.7</span></td>
<td>control visibility of datetime, require vue^2.3</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">minute-list</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.7</span></td>
<td>specify minute list, for instance [‘00’, ‘15’, ‘30’, ‘45’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hour-list</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.7</span></td>
<td>specify hour list, for instance [‘09’, ‘10’, ‘11’, ‘12’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default-selected-value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.4.1</span></td>
<td>set default selected value, works only when value is empty</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">compute-hours-function</span></td>
<td><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.5</span></td>
<td>dynamically set hours list, params <code>(value, isToday, generateRange)</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">compute-days-function</span></td>
<td><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.1</span></td>
<td>dynamically set days list, params <code>({year, month, min, max}, generateRange)</code></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>trigger element content</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td>title slot</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.6</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>$emits when value changes, <code>(newVal)</code></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-clear</span></td>
<td> </td>
<td>$emits when click the button in the middle of the header</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>fires when datetime shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td><code>(type)</code>, type is one of [cancel, confirm]</td>
<td>fires when datetime hides</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.4</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-cancel</span></td>
<td> </td>
<td>fires when cancel button is clicked or mask is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.4</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-confirm</span></td>
<td> </td>
<td>fires when confirm button is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.4</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/datetime">Demo page</a></p>
<hr>
<h3>Divider_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/divider/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/divider">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/divider" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Divider.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Divider } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>title</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/divider">Demo page</a></p>
<hr>
<h3>Drawer_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/drawer/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/drawer">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/drawer" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Drawer.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Drawer } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>this component is forked from: https://github.com/bajian/vue-drawer</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.4.0</span></td>
<td>visibility of the component, use :show.sync to control the visibility(vue@^2.3.3)</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">drawer-style</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.4.0</span></td>
<td>menu container styles</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-mode</span></td>
<td><span class="type type-string">String</span></td>
<td>overlay</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.4.0</span></td>
<td>animation type, can be push or overlay</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placement</span></td>
<td><span class="type type-string">String</span></td>
<td>left</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.4.0</span></td>
<td>placement, left or right</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>page content container</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.4.0</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">drawer</span></td>
<td>drawer menu container</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.4.0</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/drawer">Demo page</a></p>
<hr>
<h3>Flexbox_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/flexbox/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/flexbox">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/flexbox" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Flexbox.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Flexbox } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-component-name">Flexbox</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">gutter</span></td>
<td><span class="type type-number">Number</span></td>
<td>8</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>gap size (px)</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">orient</span></td>
<td><span class="type type-string">String</span></td>
<td>horizontal</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>can be in [‘horizontal’, ‘vertical’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">justify</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td><code>justify-content</code> in <code>flex</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">align</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td><code>align-items</code> in <code>flex</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">wrap</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td><code>flex-wrap</code> in <code>flex</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">direction</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td><code>flex-direction</code> in <code>flex</code></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content slot for <code>flexbox-item</code></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">FlexboxItem</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">span</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>occupied width. If not set, all flexbox-item will get the same width.</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">order</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td><code>order</code> in <code>flex</code></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content slot</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/flexbox">Demo page</a></p>
<hr>
<h3>Flow_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/flow/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/flow">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/flow" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Flow.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Flow } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-component-name">Flow</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">orientation</span></td>
<td><span class="type type-string">String</span></td>
<td>horizontal</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>orientation of flow, can be in [‘horizontal’, ‘vertical’]</td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">FlowState</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>title for state point</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">state</span></td>
<td><span class="type type-string">String</span><br><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>content showed inside state point.</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-done</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if done</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td>title for state point，default content is prop:title</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.0</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">FlowLine</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">tip</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>tip for flow line, invalid when is-done is true</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">tip-direction</span></td>
<td><span class="type type-string">String</span></td>
<td>top for horizontal flow, left for vertical flow</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>orientation of tip, can be in [‘top’, ‘right’, ‘bottom’, ‘left’]. If horizontal flow, the default is top; if vertical flow, the default is left</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-done</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if done</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">line-span</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>length of flow line. if not set, all flow-line will get the same length</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">process-span</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>50</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>percentage rate of progress which will be showed in flow line</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/flow">Demo page</a></p>
<hr>
<h3>FormPreview_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/form-preview/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/form-preview">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/form-preview" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/FormPreview.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { FormPreview } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">header-label</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>header label</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">header-value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>header value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">body-items</span></td>
<td><span class="type type-array">Array</span></td>
<td>[]</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>a list of label and value pair</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">footer-buttons</span></td>
<td><span class="type type-array">Array</span></td>
<td>[]</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button list. Default is a gray style, and the primary text is highlighted. [{style: ‘primary’, text: ‘text’, onButtonClick: fn(prop:name), link: ‘/path’}]</td>
</tr>
<tr>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/form-preview">Demo page</a></p>
<hr>
<h3>Grid_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/grid/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/grid">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/grid" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Grid.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Grid, GridItem } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-component-name">Grid</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">rows</span></td>
<td><span class="type type-number">Number</span></td>
<td>3</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.0</span></td>
<td>(deprecated after v2.6.0) the number of rows. Less than 5 will be better</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cols</span></td>
<td><span class="type type-number">Number</span></td>
<td>3</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.1</span></td>
<td>the number of columns. if there is more than one row in grid, need to set cols value, otherwise all grid items will show in one row with the same width</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-lr-borders</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.8.1</span></td>
<td>whether show left and right borders</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-vertical-dividers</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.8.1</span></td>
<td>whether show vertical dividers</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>default slot for <code>grid-item</code> list</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">GridItem</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">icon</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>icon url. if using local resources, it is better to use <code>slot=icon</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td><code>label</code> text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">link</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>vue-router’s path</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">icon</span></td>
<td>icon slot, use <code>&lt;img&gt;</code></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label</span></td>
<td>slot for label, the same func as prop:label</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/grid">Demo page</a></p>
<hr>
<h3>Group_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/group/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/group">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/group" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Group.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Group } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><code>Group</code> is a special component for wrapping form elements</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>group title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title-color</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>group title’s color</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label-width</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>common label width for child components</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label-align</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>common label text-align for child components</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label-margin-right</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>common margin right value for child components</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">gutter</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>set the marginTop value when there is no title</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content body for child components</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td>title slot</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.1</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/group">Demo page</a></p>
<hr>
<h3>Icon_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/icon/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/icon">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/icon" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Icon.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Icon } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>icon name, optional values are shown in demo</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-msg</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if used as msg icon. Icon’s font-size will be bigger(93px) than default</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/icon">Demo page</a></p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"info"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"info-circle"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warn"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"waiting"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"waiting-circle"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"safe-success"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"safe-warn"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success-circle"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success-no-circle"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"circle"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"download"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"cancel"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"search"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"clear"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span> <span class="hljs-attr">is-msg</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"info"</span> <span class="hljs-attr">is-msg</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"safe-success"</span> <span class="hljs-attr">is-msg</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"safe-warn"</span> <span class="hljs-attr">is-msg</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">icon</span>&gt;</span>
</code></pre>
<hr>
<h3>InlineCalendar_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/inline-calendar/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/inline-calendar">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/inline-calendar" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/InlineCalendar.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { InlineCalendar } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span><br><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>calendar value, use <code>v-modle</code> for binding. String (including empty) means single seleciton; array (including empty array) means multiple selection.</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">render-month</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>specify which date to render, for example [2018, 8]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">start-date</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>start date with format <code>YYYY-MM-dd</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">end-date</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>end date with format <code>YYYY-MM-dd</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-last-month</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show last month’s days</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-next-month</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show next month’s days</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">highlight-weekend</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if highlight weekend days</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">return-six-rows</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if always show six rows</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-header</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if hiding header</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-week-list</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if hiding week list</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">replace-text-list</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>replace list, for example, {‘TODAY’:‘今’}</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">weeks-list</span></td>
<td><span class="type type-array">Array</span></td>
<td>[‘Su’, ‘Mo’, ‘Tu’, ‘We’, ‘Th’, ‘Fr’, ‘Sa’]</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>week list, starting from <code>Sunday</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">render-function</span></td>
<td><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>render function to add extra contents, params <code>(line, row, dateData)</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">render-on-value-change</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if re-render calendar if value changes, should set to false when showing multi months</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disable-past</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if disable the past days, can work with start-date</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disable-future</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if disable future days, can work with end-date</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">marks</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.0</span></td>
<td>(beta) style marks for specified date list</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disable-weekend</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.0</span></td>
<td>whether disable weekends</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disable-date-function</span></td>
<td><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.0</span></td>
<td>check if a date should be disabled</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">each-day</span></td>
<td>you can custom how to display each day</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.5</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td> </td>
<td>emits when value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-view-change</span></td>
<td>(data, index)</td>
<td>fires when render month is changed</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.12</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-select-single-date</span></td>
<td>(currentValue)</td>
<td>fires when date is selected in radio mode</td>
<td><span style="font-size:12px;white-space:nowrap;">2.7.6</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">getDates</span></td>
<td> </td>
<td>get current date list</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.11</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">switchViewToToday</span></td>
<td> </td>
<td>render current month</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.12</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">switchViewToMonth</span></td>
<td>(year, month)</td>
<td>render specified year and month</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.12</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">switchViewToCurrentValue</span></td>
<td> </td>
<td>render with current value’s month</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.12</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/inline-calendar">Demo page</a></p>
<hr>
<h3>InlineLoading_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/inline-loading/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/inline-loading">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/inline-loading" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/InlineLoading.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { InlineLoading } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>require vux@^2.3.4</p>
<hr>
<h3>InlineXNumber_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/inline-x-number/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/inline-x-number">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/inline-x-number" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/InlineXNumber.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { InlineXNumber } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>50px</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>width for number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">button-style</span></td>
<td><span class="type type-string">String</span></td>
<td>square</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button style, can be ‘round’</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>min value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max</span></td>
<td><span class="type type-number">number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>max value</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/inline-x-number">Demo page</a></p>
<hr>
<h3>LoadMore_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/load-more/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/load-more">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/load-more" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/LoadMore.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { LoadMore } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-loading</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show loading icon</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">tip</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>tip text. Show dot if there is no text and loading icon</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/load-more">Demo page</a></p>
<hr>
<h3>Loading_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/loading/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/loading">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/loading" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Loading.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Loading } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of the component. Use <code>v-model</code> for binding before v2.5.7, otherwise use <code>:show</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>loading text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>fixed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>position, default is <code>fixed</code>, you can use <code>absolute</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-mask</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>transition name</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content area</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/loading">Demo page</a></p>
<hr>
<h3>Marquee_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/marquee/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/marquee">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/marquee" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Marquee.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Marquee, MarqueeItem } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-component-name">Marquee</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">interval</span></td>
<td><span class="type type-number">Number</span></td>
<td>2000</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>switch interval time</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">duration</span></td>
<td><span class="type type-number">Number</span></td>
<td>300</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>animation time</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">direction</span></td>
<td><span class="type type-string">String</span></td>
<td>up</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>direction of animation, can be in [‘up’, ‘down’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">item-height</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>item height, set value if marquee initial state is hidden</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>container of marquee items</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">MarqueeItem</span></p>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content slot</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/marquee">Demo page</a></p>
<hr>
<h3>Masker_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/masker/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/masker">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/masker" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Masker.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Masker } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">color</span></td>
<td><span class="type type-string">String</span></td>
<td>0, 0, 0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the mask’s color in rgb format, for example, ‘0, 0, 0’</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">opacity</span></td>
<td><span class="type type-number">Number</span></td>
<td>0.5</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the opacity of the mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">fullscreen</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.14</span></td>
<td>if masker is fullscreen</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content below the mask</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td>content above the mask</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/masker">Demo page</a></p>
<hr>
<h3>Msg_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/msg/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/msg">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/msg" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Msg.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Msg } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text to show operation status</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">description</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>description</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">icon</span></td>
<td><span class="type type-string">String</span></td>
<td>success</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>icon type. You can use <code>success</code>, <code>warn</code>, <code>info</code>, <code>waiting</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">buttons</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>buttons list. A button item includes <code>text</code>, <code>type</code>(the same as x-button type), <code>link</code>, <code>onClick</code></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">buttons</span></td>
<td>used for custom buttons</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">description</span></td>
<td>used for custom description</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/msg">Demo page</a></p>
<hr>
<h3>Panel_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/panel/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/panel">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/panel" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Panel.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Panel } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">header</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>header title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">footer</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>footer config, <code>{url: url, title: title}</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">list</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>content list <code>[{title, desc, src, fallbackSrc, meta:{source,date,other<span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span><span>}}</span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span>]</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>1</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>one of ‘1’, ‘2’, ‘3’, ‘4’, ‘5’</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-header</span></td>
<td> </td>
<td>emits when clicking header</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-item</span></td>
<td><code>(item)</code></td>
<td>emits when clicking item</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-footer</span></td>
<td> </td>
<td>emits when clicking footer</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/panel">Demo page</a></p>
<hr>
<h3>Picker_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/picker/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/picker">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/picker" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Picker.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Picker } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>picker value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">data</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>array list</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">columns</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>how many columns in chained-mode</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">fixed-columns</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>how many columns will show</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">column-width</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.0</span></td>
<td>custom width for each picker column, for example for a 3-column picker: [1/2, 1/5]</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>emits when value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">getNameValues</span></td>
<td> </td>
<td>get labels of current value</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.1</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/picker">Demo page</a></p>
<hr>
<h3>Popover_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/popover/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/popover">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/popover" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Popover.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Popover } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>content of the popover</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placement</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>position of the popover</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">gutter</span></td>
<td><span class="type type-number">Number</span></td>
<td>5</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the gutter between trigger element and popover arrow</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>trigger element</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td>content of the popover</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>triggers when popover shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>triggers when popover hides</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/popover">Demo page</a></p>
<hr>
<h3>PopupHeader_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/popup-header/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/popup-header">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/popup-header" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/PopupHeader.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { PopupHeader } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">left-text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>left text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">right-text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>right text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-bottom-border</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>whether show bottom border</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-left</span></td>
<td> </td>
<td>emits when left text is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-right</span></td>
<td> </td>
<td>emits when right text is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/popup-header">Demo page</a></p>
<hr>
<h3>PopupPicker_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/popup-picker/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/popup-picker">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/popup-picker" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/PopupPicker.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { PopupPicker } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p class="tip">
  other props are the same as `Picker`
</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>picker value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>popup cancel text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">confirm-text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>popup confirm text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-name</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show names instead of keys</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">inline-desc</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>description text below label</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>popup show (supports the .sync modifier next)</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value-text-align</span></td>
<td><span class="type type-string">String</span></td>
<td>right</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.0-rc.3</span></td>
<td>value’s text align</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">display-format</span></td>
<td><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.7</span></td>
<td>used to format display text on cell, param: (currentValue)</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">popup-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>popup style</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">popup-title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.0</span></td>
<td>popup title</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td>title slot, use scope.labelClass and scope.labelStyle to inherit label styles</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.7</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>emits when value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when popup shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td><code>(closeType)</code> true表示confirm(选择确认), false表示其他情况的关闭</td>
<td>emits when popup is closed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-shadow-change</span></td>
<td><code>(Array ids, Array names)</code></td>
<td>emits when picker value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.6</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/popup-picker">Demo page</a></p>
<hr>
<h3>PopupRadio_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/popup-radio/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/popup-radio">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/popup-radio" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/PopupRadio.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { PopupRadio } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>props are the same as cell’s and radio’s. Be aware that it doesnot support fillMode.</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">readonly</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.6</span></td>
<td>readonly, shown like a cell</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">popup-header</span></td>
<td>popup header slot</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.3</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">each-item</span></td>
<td>custom how label displays</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.7</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>fires when popup shows</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.5</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>fires when popup hides</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.5</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/popup-radio">Demo page</a></p>
<hr>
<h3>Popup_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/popup/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/popup">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/popup" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Popup.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Popup } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of popup, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">height</span></td>
<td><span class="type type-string">String</span></td>
<td>auto</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>popup height, works when position is top or bottom</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if closing popup when mask being clicked</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-transparent</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.9</span></td>
<td>if using transparent background</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>auto</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>if you want to set 100% width, you should use this prop. only works when position is left or right</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>bottom</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>popup position, shoule be one of [‘left’, ‘right’, ‘top’, ‘bottom’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>whether show mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">popup-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>popup style</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-deactivated</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.5</span></td>
<td>whether hide popup on deactived event when using keep-alive</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content body</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when then popup is closed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when the popup shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-first-show</span></td>
<td> </td>
<td>emits at the first time the popup shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/popup">Demo page</a></p>
<hr>
<h3>Previewer_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/previewer/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/previewer">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/previewer" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Previewer.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Previewer } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<blockquote>
<p>please avoid using large pictures or they may crash your browser(especially on Android).</p>
</blockquote>
<p>example for list:</p>
<pre class="hljs"><code>[{
  <span class="hljs-attr">msrc</span>: <span class="hljs-string">'https://placekitten.com/500/250'</span>,
  <span class="hljs-attr">src</span>: <span class="hljs-string">'https://placekitten.com/800/400'</span>,
  <span class="hljs-attr">w</span>: <span class="hljs-number">600</span>,
  <span class="hljs-attr">h</span>: <span class="hljs-number">400</span>
},
{
  <span class="hljs-attr">src</span>: <span class="hljs-string">'https://placekitten.com/1200/900'</span>,
  <span class="hljs-attr">msrc</span>: <span class="hljs-string">'https://placekitten.com/120/90'</span>, <span class="hljs-comment">// thumbnail</span>
  w: <span class="hljs-number">1200</span>,
  <span class="hljs-attr">h</span>: <span class="hljs-number">900</span>
}]
</code></pre>
<p class="warning">before v2.4.0, `w` and `h` should be specified.</p>
<p>Prevewing an image by index:</p>
<pre class="hljs"><code><span class="hljs-keyword">this</span>.$refs.previewer.show(index)
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">list</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>images list</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">options</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>options for <code>photoswipe</code></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">button-after</span></td>
<td>slot after control button list</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.3</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">button-before</span></td>
<td>slot before control button list</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.3</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-close</span></td>
<td> </td>
<td>fires after closing</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.4</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-index-change</span></td>
<td> </td>
<td>fires after index changes(shall not fire on first opening slide)</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.8.1</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">goTo</span></td>
<td>(index)</td>
<td>go to specified image</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.10</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">prev</span></td>
<td> </td>
<td>go to previous image</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.10</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">v2.8.1</span></td>
<td> </td>
<td>go to next image</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.10</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">getCurrentIndex</span></td>
<td> </td>
<td>get current index</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.3</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/previewer">Demo page</a></p>
<hr>
<h3>Qrcode_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/qrcode/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/qrcode">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/qrcode" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Qrcode.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Qrcode } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>content, make sure to prefix with http(s) when value is a link</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">size</span></td>
<td><span class="type type-number">Number</span></td>
<td>80</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>size</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">bg-color</span></td>
<td><span class="type type-string">String</span></td>
<td><span class="type" style="width:65px;background-color:#FFFFFF">#FFFFFF</span></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>background color</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">fg-color</span></td>
<td><span class="type type-string">String</span></td>
<td><span class="type" style="width:65px;background-color:#000000">#000000</span></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>front color</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>img</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>render type, can be <code>img</code> or <code>canvas</code></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/qrcode">Demo page</a></p>
<hr>
<h3>Radio_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/radio/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/radio">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/radio" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Radio.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Radio } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<pre class="hljs"><code>  <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">radio</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"title"</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">radio</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
</code></pre>
<p><code>options</code> can be plain array, or object list with key=&gt; value:</p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> options = [ <span class="hljs-string">'China'</span>, <span class="hljs-string">'Japan'</span> ]

<span class="hljs-keyword">const</span> options2 = [{
  <span class="hljs-attr">icon</span>: <span class="hljs-string">'http://dn-placeholder.qbox.me/110x110/FF2D55/000'</span>,
  <span class="hljs-attr">key</span>: <span class="hljs-string">'001'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'radio001'</span>
}, {
  <span class="hljs-attr">icon</span>: <span class="hljs-string">'http://dn-placeholder.qbox.me/110x110/FF2D55/000'</span>,
  <span class="hljs-attr">key</span>: <span class="hljs-string">'002'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'radio002'</span>
}]
</code></pre>
<p class="tip">`radio` should be used in `Group`.</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>radio value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">options</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>option list, can be plain array or array with <code>key=&gt;value</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">fill-mode</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if add an option user can fill</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">fill-placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder for fill input</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">fill-label</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label for fill input</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.8</span></td>
<td>disable selecting</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">selected-label-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.4.0</span></td>
<td>set selected label style</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">each-item</span></td>
<td>custom how to display each item</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.5</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/radio">Demo page</a></p>
<hr>
<h3>Range_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/range/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/range">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/range" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Range.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Range } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">decimal</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show decimals when value is changed</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>min number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max</span></td>
<td><span class="type type-number">Number</span></td>
<td>100</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>max number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">step</span></td>
<td><span class="type type-number">Number</span></td>
<td>1</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>step value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if disabled</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">minHTML</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>custom html template for min value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">maxHTML</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>custom html template for max value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled-opacity</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>opacity value when is disabled</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">rangeBarHeight</span></td>
<td><span class="type type-number">Number</span></td>
<td>1</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>range bar’s height</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>emits when value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.2</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/range">Demo page</a></p>
<hr>
<h3>Rater_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/rater/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/rater">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/rater" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Rater.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Rater } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max</span></td>
<td><span class="type type-number">Number</span></td>
<td>5</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>total star number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>selected value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if disabled</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">star</span></td>
<td><span class="type type-string">String</span></td>
<td>★</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>start’s symbol text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">active-color</span></td>
<td><span class="type type-string">String</span></td>
<td><span class="type" style="width:65px;background-color:#fc6">#fc6</span></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>symbol color when selected</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">margin</span></td>
<td><span class="type type-number">Number</span></td>
<td>2</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>margin value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">font-size</span></td>
<td><span class="type type-number">Number</span></td>
<td>25</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>font size</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.9</span></td>
<td>min value</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/rater">Demo page</a></p>
<hr>
<h3>Scroller_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/scroller/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/scroller">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/scroller" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Scroller.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Scroller } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>current pulldown and pullup status, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">height</span></td>
<td><span class="type type-string">String</span></td>
<td>viewport height</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>scroller’s height, you can use <code>height=-40</code> to make scroller set to height: <code>viewportHeight - 40px</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">lock-x</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>lock the horizontal direction</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">lock-y</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>lock the vertical direction</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scrollbar-x</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show horizontal scrollbar</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scrollbarY</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show vertical scrollerbar</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">bounce</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if use bounce effect</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">use-pulldown</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if use pulldown plugin</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">use-pullup</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if use pullup plugin</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">pulldown-config</span></td>
<td><span class="type type-object">Object</span></td>
<td>see below</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>config for pulldown plugin</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">pullup-config</span></td>
<td><span class="type type-object">Object</span></td>
<td>see below</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>config for pullup plugin</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scroll-bottom-offset</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>where to emit event:on-scroll-bottom before reaching bottom</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>scroller content, should has only one <code>div</code> root</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-scroll</span></td>
<td><code>(position)</code></td>
<td>emits when user scrolls</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-scroll-bottom</span></td>
<td> </td>
<td>emits when user scrolls to bottom. The event may emit multiple times, so you should use a variable for keeping status if you need fetching data</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-pulldown-loading</span></td>
<td> </td>
<td>emits when scroller is on pulldown-loading status</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-pullup-loading</span></td>
<td> </td>
<td>emits when scroller is on pullup-loading status</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">reset</span></td>
<td><code>(position, duration, easing)</code></td>
<td>reset scroller to reset height whenever your data is changed. easing can be one of ease-in, ease-in-out, ease, bezier(n, n, n, n)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">donePullup</span></td>
<td> </td>
<td>set pullup done after new data is fetched</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disablePullup</span></td>
<td> </td>
<td>disable pullup plugin when there is no more data</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">enablePullup</span></td>
<td> </td>
<td>enable pullup plugin</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">donePulldown</span></td>
<td> </td>
<td>set pulldown done after new data is fetched</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/scroller">Demo page</a></p>
<p>pulldown 默认配置:</p>
<pre class="hljs"><code>{
  <span class="hljs-attr">content</span>: <span class="hljs-string">'Pull Down To Refresh'</span>,
  <span class="hljs-attr">height</span>: <span class="hljs-number">60</span>,
  <span class="hljs-attr">autoRefresh</span>: <span class="hljs-literal">false</span>,
  <span class="hljs-attr">downContent</span>: <span class="hljs-string">'Pull Down To Refresh'</span>,
  <span class="hljs-attr">upContent</span>: <span class="hljs-string">'Release To Refresh'</span>,
  <span class="hljs-attr">loadingContent</span>: <span class="hljs-string">'Loading...'</span>,
  <span class="hljs-attr">clsPrefix</span>: <span class="hljs-string">'xs-plugin-pulldown-'</span>
}
</code></pre>
<p>pullup 默认配置:</p>
<pre class="hljs"><code>{
  <span class="hljs-attr">content</span>: <span class="hljs-string">'Pull Up To Refresh'</span>,
  <span class="hljs-attr">pullUpHeight</span>: <span class="hljs-number">60</span>,
  <span class="hljs-attr">height</span>: <span class="hljs-number">40</span>,
  <span class="hljs-attr">autoRefresh</span>: <span class="hljs-literal">false</span>,
  <span class="hljs-attr">downContent</span>: <span class="hljs-string">'Release To Refresh'</span>,
  <span class="hljs-attr">upContent</span>: <span class="hljs-string">'Pull Up To Refresh'</span>,
  <span class="hljs-attr">loadingContent</span>: <span class="hljs-string">'Loading...'</span>,
  <span class="hljs-attr">clsPrefix</span>: <span class="hljs-string">'xs-plugin-pullup-'</span>
}
</code></pre>
<p><span class="vux-qa">QA 如何更新数据</span></p>
<p>如果展示内容只是简单的增加或者减少，直接调用<code>reset</code>方法即可</p>
<pre class="hljs"><code><span class="hljs-keyword">this</span>.$nextTick(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
  <span class="hljs-keyword">this</span>.$refs.scroller.reset()
})
</code></pre>
<p>如果展示内容完全重载，那么需要主动设置位置让其能正确回到顶部。适用于改变筛选条件后重载数据的情况</p>
<pre class="hljs"><code><span class="hljs-keyword">this</span>.$nextTick(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
  <span class="hljs-keyword">this</span>.$refs.scroller.reset({
    <span class="hljs-attr">top</span>: <span class="hljs-number">0</span>
  })
})
</code></pre>
<p><span class="vux-qa">QA 如何设置pullup完成</span></p>
<p>方法1，直接调用ref的<code>donePullup</code>方法</p>
<pre class="hljs"><code><span class="hljs-keyword">this</span>.$refs.demo2.donePullup()
</code></pre>
<p>方法2，绑定value, 重置状态</p>
<p class="tip">自定义pullup模板同样是用v-model来绑定以获取状态变化</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">scroller</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"status"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">scroller</span>&gt;</span>
</code></pre>
<pre class="hljs"><code>data () {
  <span class="hljs-keyword">return</span> {
    <span class="hljs-attr">status</span>: {
      <span class="hljs-attr">pullupStatus</span>: <span class="hljs-string">'default'</span>
    }
  }
}
</code></pre>
<pre class="hljs"><code>// 重置状态为default
this.status.pullupStatus = 'default
</code></pre>
<p><span class="vux-qa">QA 如何设置pulldown完成</span></p>
<p>参照<code>pullup</code>, 使用方法<code>donePulldown</code>或者绑定<code>pulldownStatus</code>然后重置为<code>default</code>。</p>
<p><span class="vux-qa">QA 如何禁用或者启用pullup</span></p>
<p>在有些情况下，比如数据不多不需要上拉加载或者已经加载完成，我们需要禁用pullup<br>
同样可以调用方法 <code>disablePullup</code> 或者设置<code>pullupStatus</code>为<code>disabled</code></p>
<p>反之，则调用方法 <code>enablePullup</code> 或者设置<code>pullupStatus</code>为<code>enabled</code></p>
<p><span class="vux-qa">启用keep-alive后滚动有问题</span></p>
<p>需要在调用Scroller的页面上在 hook: <code>activated</code>上执行<code>reset</code></p>
<pre class="hljs"><code>activated () {
  <span class="hljs-keyword">this</span>.$refs.scroller.reset()
}
</code></pre>
<hr>
<h3>Search_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/search/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/search">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/search" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Search.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Search } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td>搜索(search)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td>取消(cancel)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>cancel text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>input value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">results</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>search results, [{title: ‘hello’, otherData: otherValue}], will not show when auto-fixed is false</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">auto-fixed</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if auto fixed on top when input gets focus</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">top</span></td>
<td><span class="type type-string">String</span></td>
<td>0px</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>top value when fixed on top</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>fixed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>position value when pin the component on the top, one of <code>fixed</code>, <code>absolute</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">auto-scroll-to-top</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if auto scroll to top when input gets focus</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>slot above search result</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">right</span></td>
<td>slot on the right of input</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">left</span></td>
<td>slot on the left of input</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.5</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-submit</span></td>
<td><code>(value)</code></td>
<td>emits when form is submitted</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-cancel</span></td>
<td> </td>
<td>emits when cancel button is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>emits when value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-result-click</span></td>
<td><code>(item)</code></td>
<td>emits when result item is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-focus</span></td>
<td> </td>
<td>when input gets focus</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.10</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-blur</span></td>
<td> </td>
<td>fires when input losts focus</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.3</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">setFocus</span></td>
<td> </td>
<td>set focus on input. you should call this method in a click event’s callback function on Safari</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">setBlur</span></td>
<td> </td>
<td>make input lost focus</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.6</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/search">Demo page</a></p>
<hr>
<h3>Selector_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/selector/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/selector">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/selector" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Selector.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Selector } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span><br><span class="type type-number">Number</span><br><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">direction</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>align value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">options</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>option list, <code>['one', 'two']</code> or <code>[{ key: KEY, value: VALUE }]</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">name</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form name</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">readonly</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if the select is readonly</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value-map</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.2</span></td>
<td>set a [value, label] pair for automatically transforming API data</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>emits when value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">getFullValue</span></td>
<td> </td>
<td>get full value including all the props(if option items are object)</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.2</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/selector">Demo page</a></p>
<hr>
<h3>Spinner_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/spinner/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/spinner">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/spinner" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Spinner.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Spinner } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>ios</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>icon type</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/spinner">Demo page</a></p>
<hr>
<h3>Step_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/step/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/step">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/step" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Step.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Step } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/step">Demo page</a></p>
<hr>
<h3>Sticky_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/sticky/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/sticky">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/sticky" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Sticky.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Sticky } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scroll-box</span></td>
<td><span class="type type-string">String</span></td>
<td>window</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>scroll tagget</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">check-sticky-support</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if check if sticky is supported on current browser</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">offset</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>top distance</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>content</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">bindSticky</span></td>
<td> </td>
<td>manually re-bind sticky</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.4</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/sticky">Demo page</a></p>
<hr>
<h3>Swipeout_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/swipeout/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/swipeout">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/swipeout" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Swipeout.vue" target="_blank">Demo source</a></span></p>
<p><span class="vux-component-name">Swipeout</span></p>
<p>包装子组件的wrap组件</p>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">SwipeoutItem</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">sensitivity</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">auto-close-on-button-click</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">threshold</span></td>
<td><span class="type type-number">Number</span></td>
<td>0.3</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">transition-mode</span></td>
<td><span class="type type-string">String</span></td>
<td>reveal</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">left-menu</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">right-menu</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-open</span></td>
<td> </td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-close</span></td>
<td> </td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">open</span></td>
<td><code>(direction)</code></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close</span></td>
<td> </td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">SwipeoutButton</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">background-color</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>80</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/swipeout">Demo page</a></p>
<hr>
<h3>Swiper_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/swiper/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/swiper">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/swiper" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Swiper.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Swiper } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">list</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>image list</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">direction</span></td>
<td><span class="type type-string">String</span></td>
<td>horizontal</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>swiping direction</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-dots</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show indicators</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-desc-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show description mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dots-position</span></td>
<td><span class="type type-string">String</span></td>
<td>right</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>indicator position</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dots-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>custom indicator’s classname</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">auto</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if auto playing</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">loop</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if use loop mode</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">interval</span></td>
<td><span class="type type-number">Number</span></td>
<td>3000</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>interval value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">threshold</span></td>
<td><span class="type type-number">Number</span></td>
<td>50</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>threshold value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">duration</span></td>
<td><span class="type type-number">Number</span></td>
<td>300</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>transition duration</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">height</span></td>
<td><span class="type type-string">String</span></td>
<td>180px</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>height value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">aspect-ratio</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if specified, height will be caculated automatically</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min-moving-distance</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>min distance before moving</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">v-model</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>index value, use <code>v-model</code> for binding</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-index-change</span></td>
<td><code>(currentIndex)</code></td>
<td>fires when index is changed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-get-height</span></td>
<td><code>(height)</code></td>
<td>fires after height is caculated</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.0</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/swiper">Demo page</a></p>
<hr>
<h3>Tab_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/tab/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/tab">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/tab" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Tab.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Tab, TabItem } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-component-name">Tab</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">line-width</span></td>
<td><span class="type type-number">Number</span></td>
<td>3</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">active-color</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default-color</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled-color</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">bar-active-color</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">animate</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">custom-bar-width</span></td>
<td><span class="type type-string">String</span><br><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.7</span></td>
<td>set active bar width, like <code>50px</code>. or you can use function, param is <code>(currentInex)</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">badge-label</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.5</span></td>
<td>badge label</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">badge-background</span></td>
<td><span class="type type-string">String</span></td>
<td>null</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.5</span></td>
<td>badge background color</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">badge-color</span></td>
<td><span class="type type-string">String</span></td>
<td>null</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.5</span></td>
<td>badge font color</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">prevent-default</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.2</span></td>
<td>whether prevent auto-switching tab-item when tab-item is clicked</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scroll-threshold</span></td>
<td><span class="type type-number">Number</span></td>
<td>4</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.8.1</span></td>
<td>scroll tabs threshold</td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">TabItem</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">active-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-item-click</span></td>
<td><code>(index)</code></td>
<td>emits when current tabItem is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.4</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/tab">Demo page</a></p>
<hr>
<h3>Tabbar_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/tabbar/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/tabbar">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/tabbar" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Tabbar.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Tabbar, TabbarItem } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-component-name">Tabbar</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">icon-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>icon’s classname</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>slot for tabbar items</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-index-change</span></td>
<td> </td>
<td>emits when value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.4</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-component-name">TabbarItem</span></p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">selected</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if selected, you can also use <code>v-model=&quot;index&quot;</code> on tabbar to set item selected</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">badge</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>badge text, if not specified, the badge will not show</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-dot</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show the red dot</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">link</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the url for current tabbar item, can be a url or a <code>vue-router</code> link value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">icon-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the classname for current icon, if tabbar and tabbar-item both specify icon-class, tabbar-item’s will be usePulldown</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">icon</span></td>
<td>icon area</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">icon-active</span></td>
<td>will show when current item is activated</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.8</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label</span></td>
<td>label text</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-item-click</span></td>
<td> </td>
<td>emits when tabbar item is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/tabbar">Demo page</a></p>
<hr>
<h3>Timeline_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/timeline/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/timeline">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/timeline" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Timeline.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Timeline, TimelineItem } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<hr>
<h3>Toast_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/toast/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/toast">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/toast" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Toast.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Toast } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if showing toast, use v-model for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">time</span></td>
<td><span class="type type-number">Number</span></td>
<td>2000</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>show time</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>success</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>toast type, success, warn, cancel, text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>7.6em</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>toast’s width</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-show-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if showing mask, users cannot operate other elements on the page</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>content of the toast, text or html, the same function as default slot</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>default</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.4</span></td>
<td>toast position, available values: default, top, middle, bottom</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>default slot, the content of the toast</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when toast shows</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when toast hides</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/toast">Demo page</a></p>
<hr>
<h3>ViewBox_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/view-box/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/view-box">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/view-box" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/ViewBox.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { ViewBox } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">body-padding-top</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">body-padding-bottom</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>undefined</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">header</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">bottom</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scrollTo</span></td>
<td><code>(top)</code></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">getScrollTop</span></td>
<td> </td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">getScrollBody</span></td>
<td> </td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/view-box">Demo page</a></p>
<hr>
<h3>WechatEmotion_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/wechat-emotion/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/wechat-emotion">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/wechat-emotion" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/WechatEmotion.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { WechatEmotion } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">isGif</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if using gif image</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>emotion name, list: ‘微笑’, ‘撇嘴’, ‘色’, ‘发呆’, ‘得意’, ‘流泪’, ‘害羞’, ‘闭嘴’, ‘睡’, ‘大哭’, ‘尴尬’, ‘发怒’, ‘调皮’, ‘呲牙’, ‘惊讶’, ‘难过’, ‘酷’, ‘冷汗’, ‘抓狂’, ‘吐’, ‘偷笑’, ‘可爱’, ‘白眼’, ‘傲慢’, ‘饥饿’, ‘困’, ‘惊恐’, ‘流汗’, ‘憨笑’, ‘大兵’, ‘奋斗’, ‘咒骂’, ‘疑问’, ‘嘘’, ‘晕’, ‘折磨’, ‘衰’, ‘骷髅’, ‘敲打’, ‘再见’, ‘擦汗’, ‘抠鼻’, ‘鼓掌’, ‘糗大了’, ‘坏笑’, ‘左哼哼’, ‘右哼哼’, ‘哈欠’, ‘鄙视’, ‘委屈’, ‘快哭了’, ‘阴险’, ‘亲亲’, ‘吓’, ‘可怜’, ‘菜刀’, ‘西瓜’, ‘啤酒’, ‘篮球’, ‘乒乓’, ‘咖啡’, ‘饭’, ‘猪头’, ‘玫瑰’, ‘凋谢’, ‘示爱’, ‘爱心’, ‘心碎’, ‘蛋糕’, ‘闪电’, ‘炸弹’, ‘刀’, ‘足球’, ‘瓢虫’, ‘便便’, ‘月亮’, ‘太阳’, ‘礼物’, ‘拥抱’, ‘强’, ‘弱’, ‘握手’, ‘胜利’, ‘抱拳’, ‘勾引’, ‘拳头’, ‘差劲’, ‘爱你’, ‘NO’, ‘OK’, ‘爱情’, ‘飞吻’, ‘跳跳’, ‘发抖’, ‘怄火’, ‘转圈’, ‘磕头’, ‘回头’, ‘跳绳’, ‘挥手’, ‘激动’, ‘街舞’, ‘献吻’, ‘左太极’, ‘右太极’</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/wechat-emotion">Demo page</a></p>
<hr>
<h3>XAddress_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-address/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-address">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-address" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XAddress.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code>  <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">x-address</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"title"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-address</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
</code></pre>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XAddress } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-comment">// you can import built-in data</span>
<span class="hljs-keyword">import</span> { XAddress, ChinaAddressV3Data } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-comment">// if you need older data</span>
<span class="hljs-keyword">import</span> { XAddress, ChinaAddressV1Data } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p class="tip">
you can view source data at [src/datas](https://github.com/airyland/vux/tree/v2/src/datas).
</p>
<p class="tip">`x-address` should be used in `Group`</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">raw-value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if the initial value is <code>string value</code> instead of <code>id value</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">list</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>address data</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">inline-desc</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>description text below label</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-district</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if hide district column</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value-text-align</span></td>
<td><span class="type type-string">String</span></td>
<td>right</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>align setting of <code>value</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">popup-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>popup style</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.8</span></td>
<td>popup show (supports the .sync modifier next)</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td>title slot</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.8</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when being closed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when being open</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-shadow-change</span></td>
<td><code>(Array ids, Array names)</code></td>
<td>emits when picker value is changed</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.6</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-address">Demo page</a></p>
<hr>
<h3>XButton_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-button/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-button">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-button" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XButton.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XButton } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>default</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button style type, one of default, primary, warn</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if disable the button</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button text, has the same function as default slot</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mini</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if use smaller style</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">plain</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if use plain styles which has no backgroundColor</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">action-type</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button’s type value, one of <code>submit</code>, <code>button</code>, <code>reset</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">link</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.5</span></td>
<td>vue-router path, <code>BACK</code> is alias to <code>go(-1)</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-loading</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>show loading icon</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">gradients</span></td>
<td><span class="type type-array">Array</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.4</span></td>
<td>iOS design gradients, Array length should be 2</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>button text</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-button">Demo page</a></p>
<hr>
<h3>XCircle_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-circle/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-circle">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-circle" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XCircle.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XCircle } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">stroke-width</span></td>
<td><span class="type type-number">Number</span></td>
<td>1</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>top line’s width</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">stroke-color</span></td>
<td><span class="type type-string">String</span></td>
<td><span class="type" style="width:65px;background-color:#3FC7FA">#3FC7FA</span></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>top line’s color</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">trail-width</span></td>
<td><span class="type type-number">Number</span></td>
<td>1</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>bottom line’s width</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">trail-color</span></td>
<td><span class="type type-string">String</span></td>
<td><span class="type" style="width:65px;background-color:#D9D9D9">#D9D9D9</span></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>bottom line’s color</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">percent</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>percentage value</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-circle">Demo page</a></p>
<hr>
<h3>XDialog_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-dialog/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-dialog">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-dialog" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XDialog.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XDialog } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p class="warning">
if you use `XDialog` inside `ViewBox` or use `overflowScrolling:touch`，please should import `directive:transfer-dom` to fix `z-index` invalid issue。
<br>
<br>
otherwise, you don't need to use `v-transfer-dom`.
</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { TransferDomDirective <span class="hljs-keyword">as</span> TransferDom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">directives</span>: {
    TransferDom
  }
}

</code></pre>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">x-dialog</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-dialog</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>visibility of the dialog, supports the .sync modifier</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-mask</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>transition of mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>transition of dialog body</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if closing dialog when clicking on mask</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scroll</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>[deprecated]if body content can scroll when scrolling on dialog</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.2</span></td>
<td>set dialog styles, you can use it for overwritting default width and background style</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>zIndex of mask</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>main content of the dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>emits when opening dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>emits when closing dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-dialog">Demo page</a></p>
<hr>
<h3>XHeader_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-header/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-header">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-header" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XHeader.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XHeader } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">left-options.showBack</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show back text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">left-options.backText</span></td>
<td><span class="type type-string">String</span></td>
<td>Back</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>the back text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">left-options.preventGoBack</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>stop go back when clicking</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">transition</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>title transition</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">right-options.showMore</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show more icon</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>title</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">left</span></td>
<td>left slot after backText</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">overwrite-left</span></td>
<td>overwrite left icon and text</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.2</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">right</span></td>
<td>right slot</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">overwrite-title</span></td>
<td>overwrite title content</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.3</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-more</span></td>
<td> </td>
<td>triggers when more icon is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-back</span></td>
<td> </td>
<td>triggers when left part is clicked and the prop ‘left-options.preventGoBack’ is true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-title</span></td>
<td> </td>
<td>triggers when title is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-header">Demo page</a></p>
<hr>
<h3>XIcon_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-icon/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-icon">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-icon" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XIcon.vue" target="_blank">Demo source</a></span></p>
<p class="tip">
Icons come from [Ionicons(MIT)](http://ionicons.com/)
</p>
<p><code>x-icon</code> is a virtual component，which means you don’t need to import <code>XIcon</code>, <code>vux-loader@^1.0.46</code> will transform your code into <code>inline svg</code>。</p>
<p>you can set <code>fill</code> style by its class names.</p>
<p>Currently it does not support <code>svg sprite</code>，will implement in later release.</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">x-icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"ios-arrow-up"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">x-icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"ios-arrow-up"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"30"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-icon</span>&gt;</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>icon name</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">size</span></td>
<td><span class="type type-string">String</span></td>
<td>24</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>icon size</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-icon">Demo page</a></p>
<hr>
<h3>XImg_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-img/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-img">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-img" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XImg.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XImg } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default-src</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>default image src</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">src</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>real image src</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">webp-src</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>real image src in webp format, if current browser supports webp, this image will be loaded</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">error-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>a class name will be added to the img element if loading failed</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">success-class</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>a class name will be added to the img element if loading successfully</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">offset</span></td>
<td><span class="type type-number">Number</span></td>
<td>100</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>how early you want the elements to be loaded before they’re visible</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">container</span></td>
<td><span class="type type-string">String</span></td>
<td>window</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>If you want to lazy load elements inside a scrolling container change the default value to the selector of the container</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">delay</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>delay execute lazyload function because sometimes transition between routes will cause problems</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-img">Demo page</a></p>
<hr>
<h3>XInput_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-input/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-input">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-input" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XInput.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XInput } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>input value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>text</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>input type, one of <code>text</code>,<code>number</code>,<code>email</code>,<code>password</code>,<code>tel</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-type</span></td>
<td><span class="type type-string">String</span><br><span class="type type-function">Function</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>custom validating function, should return <code>{valid:true}</code> or <code>{valid:false, msg: error msg}</code></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">required</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if is required</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-clear</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show clear icon</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>minlength for input</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>maxlength for input</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if input is disabled</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">readonly</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if input is readonly</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">debounce</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>debounce time</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder-align</span></td>
<td><span class="type type-string">String</span></td>
<td>left</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.8</span></td>
<td>placeholder align value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text-align</span></td>
<td><span class="type type-string">String</span></td>
<td>left</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>text-align setting for value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label-width</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.4</span></td>
<td>set label width which will not be overwritten by $parent.labelWidth</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.1</span></td>
<td>(beta) value mask, 9 for DIGIT, A for ALPHA, S for ALPHA AND DIGIT</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">should-toast-error</span></td>
<td><span class="type type-string">String</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.3</span></td>
<td>whether toast error when clicking on error icon</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">restricted-label</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">right</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">right-full-height</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.8.1</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-blur</span></td>
<td><code>(value, $event)</code></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-focus</span></td>
<td><code>(value, $event)</code></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-enter</span></td>
<td><code>(value, $event)</code></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-error-icon</span></td>
<td><code>(error)</code></td>
<td>fires when clicking error icon</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.3</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">focus</span></td>
<td> </td>
<td>get input focus</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">blur</span></td>
<td> </td>
<td>remove focus from input</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">reset</span></td>
<td><code>(value = '')</code></td>
<td>reset input value and clear errors</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.10</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-input">Demo page</a></p>
<hr>
<h3>XNumber_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-number/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-number">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-number" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XNumber.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XNumber } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<pre class="hljs"><code>  <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">x-number</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"title"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-number</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
</code></pre>
<p class="tip">`x-number` shoule be used in `Group`</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>form value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">min</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>minimum number of value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max</span></td>
<td><span class="type type-number">Number</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>maximum number of value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">step</span></td>
<td><span class="type type-number">Number</span></td>
<td>1</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>step value</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">fillable</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if use can fill the number</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>50px</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>width of the input element</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">button-style</span></td>
<td><span class="type type-string">String</span></td>
<td>square</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>button styles, [‘square’, ‘round’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">align</span></td>
<td><span class="type type-string">String</span></td>
<td>right</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>align setting of the selecting area</td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-number">Demo page</a></p>
<hr>
<h3>XProgress_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-progress/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-progress">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-progress" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XProgress.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XProgress } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">percent</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>percent of the progress, 0-100</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-cancel</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show the cancel button</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-cancel</span></td>
<td> </td>
<td>triggers when the cancel button is clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-progress">Demo page</a></p>
<hr>
<h3>XSwitch_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-switch/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-switch">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-switch" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XSwitch.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XSwitch } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<pre class="hljs"><code>  <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">x-switch</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"title"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-switch</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
</code></pre>
<p class="tip">`x-switch` should be used in `Group`.</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>label text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if disabled</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>component’s value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">inline-desc</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>desctiption text below the label</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">prevent-default</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>prevent from setting value on being clicked</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value-map</span></td>
<td><span class="type type-array">Array</span></td>
<td>[false, true]</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.7.0</span></td>
<td>customize not-boolean values</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>triggers when value change, params is (currentValue)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click</span></td>
<td><code>(newVal, oldVal)</code></td>
<td>triggers when being clicked</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-switch">Demo page</a></p>
<hr>
<h3>XTable_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-table/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-table">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-table" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XTable.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XTable } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">full-bordered</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.4</span></td>
<td>if show left and right border of the table</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content-bordered</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.4</span></td>
<td>if show body tr’s bottom border</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cell-bordered</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.4</span></td>
<td>if show the right border of ths and tds</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>table content</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.4</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-table">Demo page</a></p>
<hr>
<h3>XTextarea_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-textarea/metas.yml" target="_blank">Edit document</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-textarea">Demo page</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-textarea" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XTextarea.vue" target="_blank">Demo source</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XTextarea } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.8</span></td>
<td>label text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">inline-desc</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.8</span></td>
<td>description text below title</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-counter</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>if show the text length counter</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">max</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>maxlength limit</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>textarea’s value, use <code>v-model</code> for binding</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">name</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>textarea’s name</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>placeholder</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">rows</span></td>
<td><span class="type type-number">Number</span></td>
<td>3</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>textarea’s rows attribute</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cols</span></td>
<td><span class="type type-number">Number</span></td>
<td>30</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>textarea’s cols attribute</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">height</span></td>
<td><span class="type type-number">Number</span></td>
<td>0</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>height</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">readonly</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>textarea’s readonly attribute</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">disabled</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>textarea’s disabled attribute</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">autosize</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>whether set auto height for textarea</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">label</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.8</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">restricted-label</span></td>
<td>undefined</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.8</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-change</span></td>
<td><code>(value)</code></td>
<td>triggers when value changes</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-focus</span></td>
<td> </td>
<td>focus event</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.11</span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-blur</span></td>
<td> </td>
<td>blur event</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.11</span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">updateAutosize</span></td>
<td> </td>
<td>reset autosize, if value is not empty initially, you should call this function to update size</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.1</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-textarea">Demo page</a></p>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// components-27.vue?caf01260